import { createSlice } from "@reduxjs/toolkit"
import nft from "../helpers/NFTHelper"

// console.log(Object.keys(nft))

//lvl 04 - 05 -06
//SEED STRUCTURE
//lvl bg (0-1)  skin (2-3)  mouth (4) eye (5-6) mouth(7-8) chestSupported (9) chest (10) neck (11-12) head (13-14) gloveSupported (15)gloves (16)
//SEED: 00 00 0 00 00 00 00 0
// length 14
const initialState = {
  seed: '',
  lvl00: 0, // bg
  skin: 0, // lvl04-05-06
  mouth: 0, // lvl05
  lvl07: 0, // eye (different)
  lvl08: 0, // mouth (different)
  lvl10: 0, // chest
  lvl11: 0, // neck
  lvl12: 0, // head
  lvl13: 0, // gloves
  supportMouthOpen: false,
  supportChest: 0,
  supportedGloves: 0,
  assetsList: [],
}

export const nftSlice = createSlice({
  name: 'nft',
  initialState,
  reducers: {
    setSeed: (state, action) => {
      state.seed = action.payload;
    },
    setSupportMouthOpen: (state, action) => {
      state.supportMouthOpen = action.payload
    },
    setLvl00: (state, action) => {
      state.lvl00 = action.payload
    },
    setSkin: (state, action) => {
      state.skin = action.payload
    },
    setMouth: (state, action) => {
      state.mouth = action.payload
    },
    setLvl07: (state, action) => {
      state.lvl07 = action.payload
    },
    setLvl08: (state, action) => {
      state.lvl08 = action.payload
    },
    setLvl10: (state, action) => {
      state.lvl10 = action.payload
    },
    setLvl11: (state, action) => {
      state.lvl11 = action.payload
    },
    setLvl12: (state, action) => {
      state.lvl12 = action.payload
    },
    setLvl13: (state, action) => {
      state.lvl13 = action.payload
    },
    setSupportedGloves: (state, action) => {
      state.supportedGloves = action.payload
    },
    setSupportedChest: (state, action) => {
      state.supportChest = action.payload
    },
    setAssetsList: (state, action) => {
      state.assetsList = action.payload
    }
  }
})

export const {
  setSeed,
  setSupportMouthOpen,
  setLvl00,
  setSkin,
  setMouth,
  setLvl07,
  setLvl08,
  setLvl10,
  setLvl11,
  setLvl12,
  setLvl13,
  setSupportedGloves,
  setSupportedChest,
  setAssetsList
} = nftSlice.actions


export const checkIfHasMouseOpen = () => (dispatch, getState) => {
  const { skin } = getState().nft
  // console.log(skin)
  // console.log(nft.skins)
  // console.log(nft.skins[Object.keys(nft.skins)[skin]])
  if (nft.skins[Object.keys(nft.skins)[skin]].includes("lvl05-mouth-back-open.png")) {
    dispatch(setSupportMouthOpen(true))
  } else {
    dispatch(setSupportMouthOpen(false))
    dispatch(setMouth(0))
  }
}

export const updateSeed = (seed = undefined) => (dispatch, getState) => {
  let newSeed = seed;
  if (seed === undefined || seed.length < 17) {
    newSeed = Math.floor(Math.random() * 100000000000000000)
  }
  // console.log(newSeed)
  const seedIndexed = newSeed.toString().split("");
  // console.log(seedIndexed)
  // console.log(parseInt(seedIndexed[2] + seedIndexed[3]) % Object.keys(nft["skins"]).length)
  dispatch(setSkin(parseInt(seedIndexed[2] + seedIndexed[3]) % Object.keys(nft["skins"]).length))
  // console.log(parseInt(seedIndexed[4]))
  dispatch(setMouth(parseInt(seedIndexed[4])))
  dispatch(checkIfHasMouseOpen())
  // console.log(parseInt(seedIndexed[0]) % nft["lvl00-bg"].length)
  dispatch(setLvl00(parseInt(seedIndexed[0] + seedIndexed[1]) % nft["lvl00-bg"].length))
  // console.log(parseInt(seedIndexed[5] + seedIndexed[6]) % nft["lvl07-eye"].length)
  dispatch(setLvl07(parseInt(seedIndexed[5] + seedIndexed[6]) % nft["lvl07-eye"].length))
  const {mouth} = getState().nft
  // console.log(parseInt(seedIndexed[7] + seedIndexed[8]) %  ( mouth ? nft["lvl08-mouth-open"].length : nft["lvl08-mouth-closed"].length))
  dispatch(setLvl08(parseInt(seedIndexed[7] + seedIndexed[8]) %  ( mouth ? nft["lvl08-mouth-open"].length : nft["lvl08-mouth-closed"].length)))
  // console.log(parseInt(seedIndexed[9] + seedIndexed[10]) % nft["lvl10-chest"].length)
  dispatch(setSupportedChest(parseInt(seedIndexed[9]) % 2))
  dispatch(setLvl10(parseInt(seedIndexed[10]) % nft["lvl10-chest"].length))
  // console.log(parseInt(seedIndexed[11] + seedIndexed[12]) % nft["lvl11-neck"].length)
  dispatch(setLvl11(parseInt(seedIndexed[11] + seedIndexed[12]) % nft["lvl11-neck"].length))
  // console.log(parseInt(seedIndexed[13] + seedIndexed[14]) % nft["lvl12-head"].length)
  dispatch(setLvl12(parseInt(seedIndexed[13] + seedIndexed[14]) % nft["lvl12-head"].length))
  // console.log(parseInt(seedIndexed[15]) % nft["lvl13-glove"].length)
  dispatch(setSupportedGloves(parseInt(seedIndexed[15]) % 2))
  dispatch(setLvl13(parseInt(seedIndexed[16]) % nft["lvl13-glove"].length))
  // console.log(getState().nft)
  dispatch(setSeed(newSeed))
  dispatch(updateAssetsList())
}

export const updateAssetsList = () => (dispatch, getState) => {
  const {lvl00,
    skin,
    mouth,
    lvl07,
    lvl08,
    lvl10,
    lvl11,
    lvl12,
    lvl13,
    supportedGloves
  } = getState().nft

    let tempAssetsList = []
    tempAssetsList.push("lvl00-bg/"+nft["lvl00-bg"][Object.keys(nft["lvl00-bg"])[lvl00]])
    if (nft.skins[Object.keys(nft.skins)[skin]].includes("lvl00-glow.png")) {
      tempAssetsList.push(Object.keys(nft.skins)[skin]+ "/lvl00-glow.png")
    }
    tempAssetsList.push(Object.keys(nft.skins)[skin]+ "/lvl04-body.png")
    tempAssetsList.push("lvl10-chest/"+nft["lvl10-chest"][Object.keys(nft["lvl10-chest"])[lvl10]])
    tempAssetsList.push("lvl11-neck/"+nft["lvl11-neck"][Object.keys(nft["lvl11-neck"])[lvl11]])
    tempAssetsList.push(Object.keys(nft.skins)[skin]+ (mouth ? "/lvl05-mouth-back-open.png" : "/lvl05-mouth-back-closed.png"))
    tempAssetsList.push(Object.keys(nft.skins)[skin]+"/lvl06-eye-back.png")
    tempAssetsList.push("lvl07-eye/"+nft["lvl07-eye"][Object.keys(nft["lvl07-eye"])[lvl07]])
    tempAssetsList.push((mouth ? "lvl08-mouth-open/"+nft["lvl08-mouth-open"][Object.keys(nft["lvl08-mouth-open"])[lvl08]] : "lvl08-mouth-closed/"+nft["lvl08-mouth-closed"][Object.keys(nft["lvl08-mouth-closed"])[lvl08]]))
    tempAssetsList.push("lvl12-head/"+nft["lvl12-head"][Object.keys(nft["lvl12-head"])[lvl12]])
    if (supportedGloves && Object.keys(nft["lvl13-glove"])[lvl13]) {
      tempAssetsList.push("lvl13-glove/"+nft["lvl13-glove"][Object.keys(nft["lvl13-glove"])[lvl13]])
    }
    dispatch(setAssetsList(tempAssetsList))
}

export default nftSlice.reducer
